import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from './actions/index'
import axios from 'axios'
import $ from 'jquery'
import _ from 'underscore'

import ToggleOpenClose from './components/ToggleOpenClose'
import PreviousQuestion from './components/PreviousQuestion'
import PreviousAnswer from './components/PreviousAnswer'
import XMPChart from './components/XMPChart'
import SelectMulti from './components/SelectMulti'
import Select from './components/Select'
import Date from './components/Date'
import Checkbox from './components/Checkbox'
import Radio from './components/Radio'
import Slider from './components/Slider'
import Weight from './components/Weight'

class App extends Component {
  state = {
    open: false,
    saving: false,
    vectoredQuestion: false,
    selectedVectorChoice: null
  }
  openContainer = (event) => {
    event.preventDefault()
    this.setState(({open}) => {
      return {
        open: !open
      }
    })
  }
  sortedValue = () => {
    if (Array.isArray(this.props.fill.value)) {
      this.props.dispatch(actions.sortFillValue())
    }
    return this.props.fill.value;
  }
  niceValue = () => {
    var self = this;
    return _.map(
      _.filter(self.props.gap.answers, function (item) {
        return _.contains(_.isArray(self.sortedValue()) ? self.sortedValue() : [self.sortedValue()], item.value||item);
      }),
      function(match) { return match.text || match; }
    ).join(' • ') || this.sortedValue();
  }
  saveFill = () => {
    var self = this;
    if (!this.state.saving) {
      this.setState((state) => {
        return {
          saving: true
        }
      })
      var requestBody = {
        answer: this.props.fill.answer,
        privacy: this.props.fill.privacy,
        value: this.props.fill.value,
        gap_id: this.props.gap.id
      }
      if(this.props.fill.hasOwnProperty('weight')) {
        requestBody.weight = this.props.fill.weight
      }
      if(this.props.vectoredQuestion) {
        requestBody.value = {};
        requestBody.value[this.props.selectedVectorChoice] = this.props.fill.value
      }
      //Taken from bbmodel validate function
      var isValid = (!requestBody.gap_id) ? "no gap"
        : (Array.isArray(requestBody.value) && (requestBody.value.length === 0)) ? "empty list"
          : (requestBody.value === '' || typeof requestBody.value == 'undefined') ? "empty value"
            : null;
      if (isValid === null) {
        this.props.dispatch(actions.xmpSave(this.props.gap.id))

        this.props.dispatch(actions.postFill(requestBody))
          .then((response) => {
            self.nextGap()
            self.remount();
            self.setState((state) => {
              return {
                saving: false
              }
            })
          })
          .catch((error) => {
            self.setState((state) => {
              return {
                saving: false
              }
            })
            // console.log(error)
          })
      }
    }
  }
  componentDidMount() {
    var stowed = this.load()
    this.setState((state) => {
      return {
        open: stowed.open,
        saving: stowed.saving
      }
    })

    // this.props.dispatch(actions.onLoad(stowed))

    this.nextGap()
  }
  componentWillUpdate(nextProps, nextState) {
    if (this.props.fill.value !== nextProps.fill.value) {
      this.setState((state) => {
        return {
          saving: false
        }
      })
    }
    if (nextState.open !== this.state.open) {
      this.stow()
    }
  }

  // componentWillUnmount() {
  //   this.stow()
  //   alert(JSON.parse(localStorage.getItem('xmp')))
  // }
  changePrivacy = (privacy) => {
    //Change privacy fill
    //fill.privacy = 'private or members
  }
  skip = () => {
    this.props.dispatch(actions.skipGap())
    this.saveFill();
  }
  remount = () => {
    var self = this;
    var $selfel = $(this.$el);
    console.log($selfel)
    this.props.dispatch(actions.updateFillAnswer(''))
    //scroll answer window
    var scrolly = function($div) {
      var div = $div[0];
      $div.animate({
        scrollTop: div.scrollHeight + div.clientHeight
      }, 200);
    };
    scrolly($selfel.find(".xmp-answered-container:first"));
  }
  load = () => {
    if (window.localStorage) {
      try {
        var stowed = {...JSON.parse(localStorage.getItem('xmp'))};
        delete stowed.gap;
        delete stowed.fill;
        return stowed;
      } catch(err) {
        return {};
      }
    }
  }
  stow = () => {
    if (window.localStorage) {
      var stowstring = JSON.stringify({...this.props.state, ...this.state});
      if (stowstring != '{}') localStorage.setItem('xmp', stowstring);
    }
  }
  nextGap = () => {
    var self = this;
    var answer = {gap:{}};
    var gap_id;
    if (this.props.gap) {
      gap_id = this.props.gap.id;
      answer.gap = this.props.gap;
      answer.title    = this.props.gap.title||'';
      answer.response = this.props.gap.response||'';
      if(this.props.gap.hasOwnProperty('vector_answers')) {
        answer.vectorChoice = this.props.selectedVectorChoice;
      }
      this.props.dispatch(actions.destroyView())
    }
    if(this.props.fill) {
      answer.answer = this.props.fill.answer||this.niceValue()||'';
    }
  console.log(answer)
    this.props.dispatch(actions.resetFill(answer))

    this.stow();

    this.props.dispatch(actions.getGaps())
      .then((body) => {
        if(this.props.gap.id) {
          this.props.dispatch(actions.gapLoad(this.props.gap.id))
        } else if (gap_id) {
          this.matchesExhausted();
        }
      })
      .catch((error) => [
        // console.log(error)
      ])
  }
  setGap = (answeredQuestion) => {
    var gap_id = answeredQuestion.gap.id;
    var gap_title = answeredQuestion.title

    // Need to remove specific answer for vectored questions
    var filteredAnswers = _.reject(this.props.answered, function(ans) {
      if(answeredQuestion.hasOwnProperty('vectorChoice')) {
        return ans.gap.id == gap_id && ans.title == gap_title && ans.vectorChoice == answeredQuestion.vectorChoice
      }
      return ans.gap.id == gap_id && ans.title == gap_title //Check incase for vectored questions
    }); //remove prior answer if changing

    this.props.dispatch(actions.removeGapForEdit(filteredAnswers))

    this.props.dispatch(actions.setGap(gap_id, answeredQuestion))
  }
  matchesExhausted = () => {
    this.stow(); //last gap filled. save state to avoid blip
    var requestBody = {...this.props.fill, gap_id:'bc.event', value:'MATCHES_EXHAUSTED', privacy:'private'}
    this.props.dispatch(actions.matchesExhausted(requestBody))
  }
  render() {
    const { open, gap, answered, fill } = this.props

    const previousQuestions = answered.map((prev, index) => (
      <div key={index}>
        <PreviousQuestion prev={prev} index={index}/>
        {(prev.answer) ? <PreviousAnswer setGap={this.setGap} prev={prev}/> : null}
        {(prev.gap.hasOwnProperty('reward') && prev.gap.reward !== 'none') ?
          (<XMPChart gap_id={prev.gap.id} type={prev.gap.reward || 'pie'}/>)
          : null
        }
        <br/>
      </div>
    ))
    var answers = ''
    if(gap.view == 'radio') {
      answers = <Radio answers={gap.answers}/>
    } else if(gap.view == 'selectmulti') {
      answers = <SelectMulti answers={gap.answers}/>
    } else if(gap.view == 'select') {
      answers = <Select answers={gap.answers}/>
    } else if(gap.view == 'date') {
      answers = <Date answers={gap.answers}/>
    } else if(gap.view == 'checkbox') {
      answers = <Checkbox answers={gap.answers}/>
    } else if(gap.view == 'slider') {
      answers = <Slider answers={gap.answers}/>
    } else if(gap.view == 'weight') {
      answers = <Weight answers={gap.answers}/>
    }
    /*<div style={gap.hasOwnProperty('id') ? {} : {'display': 'none'}} id="xmpapp"*/
    return (
      <div style={gap.hasOwnProperty('id') ? {} : {}} id="xmpapp"
           className={"xmp-container-outer " + ((this.state.open) ? "open" : "closed")} ref={(container) => this.$el = container}>
        <div className="xmp-container">
          <h3 className="xmp-title"> Health Profile <a className="xmp-help" data-dropdown="xmp-help-drop" aria-controls="xmp-help-drop" aria-expanded="false"></a></h3>
          <div id="xmp-help-drop" className="f-dropdown" data-dropdown-content="" aria-hidden="true" tabIndex="-1">
            Health Profiles are a summary of your conditions, treatments, and other health-related information.
          </div>

        <div className="xmp-answered-container">
          <div className="xmp-answered">
            { previousQuestions }
            {(answered.length) ?
              <div className="xmp-thanks">{ answered[answered.length - 1].response || 'Thanks for your answer'}</div>
              : null
            }
          </div>
        </div>


          <div className="xmp-current-question">
            <div className="xmp-question">
              <span>{gap.title || 'Health Profile Question'}<a style={this.state.open ? {'visbility': 'hidden'} : {}} className={'xmp-privacy-select ' + (fill.privacy !== 'private' ? 'shared' : 'private')} data-options="align:top" data-dropdown="test-drop-current" aria-controls="test-drop-current" aria-expanded="false"></a>
                <ul id="test-drop-current" className="f-dropdown" data-dropdown-content aria-hidden="true" tabIndex="-1">
                  <li><a onClick={this.changePrivacy('private')} className="xmp-private">Private</a></li>
                  <li><a onClick={this.changePrivacy('members')} className="xmp-shared">Shared with members</a></li>
                </ul>
              </span>
            </div>


            <div className="xmp-answer-area row collapse">
              <div className="xmp-answer small-10 columns">


                {/*Use dynamic component to render A*<Checkbox answers={["What?"]}/>*/}

                { answers
                }

                <div className="xmp-save-button">
                  <a className="button" onClick={this.saveFill} disabled={this.state.saving}>Save</a>
                </div>
              </div>
              <div className="xmp-skip small-2 columns" onClick={this.skip}>
                <a>Skip</a>
              </div>
            </div>
          </div>


          <ToggleOpenClose toggle={this.openContainer}/>


        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, props) => ({
    open: state.app.open,
    gap: state.app.gap,
    answered: state.app.answered,
    vectoredQuestion: state.app.vectoredQuestion,
    selectedVectorChoice: state.app.selectedVectorChoice,
    fill: state.app.fill,
    state: state.app
  }
)

const Container = connect(mapStateToProps)(App);

export default Container;



// WEBPACK FOOTER //
// ./src/App.js